import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Totally Bamboo — Returning-customers (reorder) campaign (adc_yj5yuad7sc).
// Real spend/conversions from ANALYTICS.ADS.CAMPAIGN_PERIODS; reorder sales are
// modeled (reorderConversions * new-customer AOV) — see realBrandData.ts.
export const campTbReorder: FaireAdCampaignEntity = {
  token: "camp_tb_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_totally_bamboo",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 3000,
  startedRunningAt: "2025-02-13",
  segmentMetrics: {
    numReorderConversions: 471,
    salesDollars: 140829,
    totalAdsSpendDollars: 13839,
    returnOnAdSpend: 10.18,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-07-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
